import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label = '¡Quiero el 48 Hrs AI Cash Machine!',
  subLabel,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-21" data-mp="qk21j7bspmfj">
      <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 24
    }} className={`flex w-full items-center justify-center gap-3 rounded-xl bg-[#22a447] text-center font-extrabold text-white shadow-[0_10px_30px_-10px_rgba(34,164,71,0.8)] ring-1 ring-inset ring-white/20 hover:bg-[#1e9440] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#22a447]/50 ${size === 'lg' ? 'px-6 py-4 text-base sm:text-lg md:text-xl' : 'px-5 py-3 text-sm sm:text-base'}`} data-id="element-22" data-mp="qiz9gw2qldy1">
        <ShoppingCartIcon className={size === 'lg' ? 'h-6 w-6 shrink-0' : 'h-5 w-5 shrink-0'} aria-hidden="true" data-id="element-23" data-mp="39z18vef4anv1" />
        <span data-id="element-24" data-mp="3jwns2d3g91kt">{label}</span>
      </motion.a>
      {subLabel ? <p className="mt-3 text-center text-xs font-medium text-white/50" data-id="element-25" data-mp="3juuiaoxji18l">{subLabel}</p> : null}
    </div>;
}